{
    "domain": "lobbycloudgate.amx-digital.com",
    "clientId": "QDIf0c5jIBhsGN6l6PzvYJMZa4FzcKiw",
    "authorizationParams": {
        "audience": "https://de-combustible"
    }
}